<template>
  <aside class="sideRight">
    <div class="online_consu center">在线<br />咨询</div>

    <el-tooltip
      class="item"
      effect="light"
      content="1979721745"
      placement="left"
    >
    <div class="center"><svg-icon icon-class="qq"></svg-icon></div>
    </el-tooltip>
    
    <el-tooltip
      class="item"
      effect="light"
      content="dsnxs"
      placement="left"
    >
      <div class="center"><svg-icon icon-class="wx"></svg-icon></div>
    </el-tooltip>

    <div class="r90 center" @click="backToTop">
      <svg-icon icon-class="jt_right"></svg-icon>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    visibilityHeight: {
      type: Number,
      default: 400,
    },
    backPosition: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    isshows: true,
  }),

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight;
    },
    backToTop() {
      if (this.isMoving) return;
      const start = window.pageYOffset;
      let i = 0;
      this.isMoving = true;
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
          this.isMoving = false;
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 16.7);
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
  },
};
</script>

<style lang="scss" scoped>
.sideRight {
  height: 300px;
  width: 70px;
  position: fixed;
  z-index: 9999;
  right: 70px;
  top: 50%;
  font-size: 30px;
  color: #0867ea;
  > div {
    width: 60px;
    height: 60px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    background-color: #fff;
    margin-bottom: 10px;
    &:hover {
      background-color: #eee;
    }
  }

  .online_consu {
    font-size: 18px;
    background-color: #0465ea;
    color: #fff;

    &:hover {
      background-color: #0760dd;
    }
  }

  .r90 {
    transform: rotate(-90deg);
  }
}
</style>